var ProblemsModule = /** @class */ (function () {
    function ProblemsModule() {
    }
    return ProblemsModule;
}());
export { ProblemsModule };
